"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const client_library_1 = require("@seneca/client-library");
class UserHasReachedMaximumNumberOfEnroledClasses extends client_library_1.ExtendableError {
    constructor(message) {
        super(message);
        this.message = message;
    }
}
exports.default = UserHasReachedMaximumNumberOfEnroledClasses;
//# sourceMappingURL=UserHasReachedMaximumNumberOfEnroledClasses.js.map